import {
    FETCH_ALL_PROMO_DATA,
  } from '../constants/ActionTypes'
  
  const INITIAL_STATE = { promo_data: null };
  
  export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
      case FETCH_ALL_PROMO_DATA:
        return { ...state, promo_data: action.payload };
      default:
        return state;
    }
  }
  